/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';
import { createPresetSelections, createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';
import { fetchUserMrdImpcSelectionsRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { departureMailProcessingCenterCheckedActionCreator } from '../../../wizard/target-node-mrd-impc-selector/redux/actions/DeparturePostalOperatorActions';
import {
  saveGlobalSelectionMrdImpcRequestActionCreator,
  deleteGlobalSelectionMrdImpcRequestActionCreator, setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import SaveSelectionModal from '../components/SaveSelectionModal';
import Button from '../../../../core/modules/common/components/Button';
import EditIMPCSelectionModal from '../../../wizard/target-node-mrd-impc-selector/components/EditIMPCSelectionModal';
import WarningModal from '../../../common/components/WarningModal';
import { getDeparturePostalOperators } from '../../../wizard/target-node-mrd-impc-selector/redux/selectors/PostalOperatorSelectors';

function operatorSelectorSelector(props, state) {
  switch (props.operatorType) {
    case OperatorTypes.DEPARTURE:
      return state.mrdPostalOperatorSelector.departure;
    case OperatorTypes.ARRIVAL:
      return state.mrdPostalOperatorSelector.arrival;
    default:
      return state.mrdPostalOperatorSelector.departure;
  }
}

const mapStateToProps = (state, props) => ({
  selections: operatorSelectorSelector(props, state).selections,
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
});

class AdminPresetMrdImpcSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DEPARTURE: { activeSelection: 'Your last selection' },
      ARRIVAL: { activeSelection: 'Your last selection' },
      newSelection: '',
      newPresetButtonDisabled: false,
      checkedMailProcessingCenters: [],
      name: '',
      showDeleteSelectionModal: false,
      showEditSelectionModal: false,
      showSaveSelectionModal: false,
      showOverwriteNewSelectionModal: false,
      showOverwriteSelectionModal: false,
      saveSelectionCheckedMailProcessingCenters: [],
      saveSelectionSelections: [],
      nameUi: '',
    };
  }

  componentDidMount() {
    const {
      operatorType,
    } = this.props;
    this.props.fetchUserMrdImpcSelectionsRequestActionCreator(operatorType);
  }

  componentDidUpdate(prevProps) {
    const { selections } = this.props;
    if (selections !== prevProps.selections) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        newSelection: selections,
      });
    }
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  // eslint-disable-next-line react/sort-comp
  openEditSelectionModal = (e, selection) => {
    e.stopPropagation();
    this.setState({
      showEditSelectionModal: true,
      saveSelectionCheckedMailProcessingCenters: createPresetSelectionsOnSave(this.props.checked, this.props.departurePostalOperatorsNodes),
      saveSelectionSelections: this.props.selections,
      nameUi: selection.name,
    });
  };

  editSelection = ({ name, checkedMailProcessingCenters }) => {
    this.setState({
      name,
      checkedMailProcessingCenters,
    });
    if (name && name !== this.state.nameUi) {
      this.setState({
        showOverwriteNewSelectionModal: true,
        showOverwriteSelectionModal: false,
      });
    } else {
      this.setState({
        showOverwriteNewSelectionModal: false,
        showOverwriteSelectionModal: true,
      });
    }
    this.setState({
      newPresetButtonDisabled: false,
    });
    this.closeEditSelectionModal();
  };

  overwriteNewSelection = () => {
    // eslint-disable-next-line max-len
    this.props.saveGlobalSelectionMrdImpcRequestActionCreator(this.state.name, this.state.checkedMailProcessingCenters);
    this.props.setTabButtonStatus(false);
    this.onCloseNewOverwriteModal();
  };

  overwriteSelection = () => {
    // eslint-disable-next-line max-len
    this.props.saveGlobalSelectionMrdImpcRequestActionCreator(this.state.nameUi, this.state.checkedMailProcessingCenters);
    this.props.setTabButtonStatus(false);
    this.onCloseOverwriteModal();
  };

  closeEditSelectionModal = () => {
    this.setState({
      showEditSelectionModal: false,
    });
  };

  onCloseOverwriteModal = () => {
    this.setState({
      showOverwriteSelectionModal: false,
    });
  };

  onCloseNewOverwriteModal = () => {
    this.setState({
      showOverwriteNewSelectionModal: false,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  applySelection = (e, selection) => {
    const reportDef = {
      locationType: 'IMPC',
    };
    if (this.props.operatorType === OperatorTypes.DEPARTURE) {
      this.props
        .departureMailProcessingCenterCheckedActionCreator(
          createPresetSelections(selection.impcCodes, this.props.operators),
          reportDef,
        );
    }
    this.setState({
      [this.props.operatorType]: { activeSelection: selection.name },
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      nameUi: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteGlobalSelectionMrdImpcRequestActionCreator(this.state.nameUi);
    this.onCloseModal();
  };

  saveSelection = ({ name }) => {
    const newPreset = [...this.props.selections];
    newPreset.unshift({ name, scope: 'GLOBAL', impcCodes: [] });
    this.setState({
      newSelection: newPreset,
      newPresetButtonDisabled: true,
    });
    this.closeSaveSelectionModal();
  };

  render() {
    const {
      operatorType,
    } = this.props;
    const {
      newSelection,
      newPresetButtonDisabled,
      showDeleteSelectionModal,
      showEditSelectionModal,
      showSaveSelectionModal,
      showOverwriteNewSelectionModal,
      showOverwriteSelectionModal,
    } = this.state;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.admin.list.mrdimpc.title.label"
            values={{ operatorType }}
          />
          <Button
            className="sidebar-new-preset-button"
            text="app.selection.new.preset"
            onClick={() => this.openSaveSelectionModal()}
            disabled={newPresetButtonDisabled}
          />
        </div>
        {newSelection && newSelection.length > 0 ? (
          <div className="user-selections">
            {showDeleteSelectionModal &&
            <DeleteModal
              headerFormattedMessageId="app.warning.delete.save.operator.selection"
              onCloseModal={this.onCloseModal}
              deleteSelection={this.deleteSelection}
            />}
            {showOverwriteSelectionModal &&
            <WarningModal
              headerFormattedMessageId="app.warning.save.overwrite.operator.selection"
              onCloseModal={this.onCloseOverwriteModal}
              deleteSelection={this.overwriteSelection}
            />
            }
            {showOverwriteNewSelectionModal &&
            <WarningModal
              headerFormattedMessageId="app.warning.save.new.overwrite.operator.selection"
              onCloseModal={this.onCloseNewOverwriteModal}
              deleteSelection={this.overwriteNewSelection}
            />
            }
            {showEditSelectionModal &&
            <EditIMPCSelectionModal
              saveSelection={this.editSelection}
              closeModal={this.closeEditSelectionModal}
              checkedMailProcessingCenters={this.state.saveSelectionCheckedMailProcessingCenters}
              selections={this.state.saveSelectionSelections}
              name={this.state.nameUi}
            />
            }
            {showSaveSelectionModal &&
            <SaveSelectionModal
              saveSelection={this.saveSelection}
              closeModal={this.closeSaveSelectionModal}
              selections={this.props.selections}
              title="app.save.empty.new.preset"
            />
            }
            <ul className="global-ul">
              { newSelection
                  .filter(selection => selection.scope === 'GLOBAL' && selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state[operatorType].activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="global-icon"
                        key={selection.name}
                        type="button"
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      <button
                        type="button"
                        className="global-icon-edit"
                        onClick={e => this.openEditSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="save" />
                      </button>
                      {selection.name}
                    </li>
                  )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserMrdImpcSelectionsRequestActionCreator,
  deleteGlobalSelectionMrdImpcRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  saveGlobalSelectionMrdImpcRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

AdminPresetMrdImpcSidebarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserMrdImpcSelectionsRequestActionCreator: PropTypes.func,
  deleteGlobalSelectionMrdImpcRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  saveGlobalSelectionMrdImpcRequestActionCreator: PropTypes.func,
  operatorType: PropTypes.string,
  operators: PropTypes.arrayOf(PropTypes.object),
  checked: PropTypes.arrayOf(PropTypes.string),
  setTabButtonStatus: PropTypes.func,
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
};

export const ConnectedAdminPresetMrdImpcSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminPresetMrdImpcSidebarContainer);

export default (ConnectedAdminPresetMrdImpcSidebarContainer);

